import { inject } from 'aurelia-framework';
import { AuthService } from 'pages/login/service';

@inject(AuthService)
export class Topbar {
    constructor(authService) {
        this.authService = authService;
    }

    async attached() {
        //await this.authService.msalInstance.handleRedirectPromise();
        this.user = this.authService.user;
        this.db = window.localStorage.getItem('db');
    }

    logout() {
        this.authService.logout();
    }

    changeDatabase() {
        window.localStorage.setItem('db', this.db === 'live' ? 'sandbox' : 'live');
        window.location.reload();
    }
}